import { Injectable } from '@angular/core';
import { MerchantService } from '@galaxy/billing';
import { map, Observable, shareReplay, switchMap } from 'rxjs';
import { AccountGroupService } from '../account-group';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(
    private readonly accountGroupService: AccountGroupService,
    private readonly merchantService: MerchantService,
  ) {}

  getMarketCurrency(): Observable<string> {
    return this.accountGroupService.currentAccountGroup$.pipe(
      switchMap((accountGroup) =>
        this.merchantService
          .getMultiRetailConfigurations(accountGroup.partnerId, [accountGroup.marketId])
          .pipe(map((resp) => resp.get(accountGroup.marketId)?.currencyCode ?? 'USD')),
      ),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
  }
}
